<template>
  <div>
    <modal size="lg" :show.sync="openEntity" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        Add Entity ID
      </h6>
      <AddTemplateEntity />
      <template slot="footer">
        <base-button type="primary">Create New Entity</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="openEntity = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <div class="flex items-center cursor-pointer">
      <feather-icon icon="ChevronLeftIcon" class="mr-2"></feather-icon>
      <p class="font-semibold">Back</p>
    </div>

    <div class="mt-8">
      <div class="flex">
        <div class="w-1/2 pr-6">
          <base-input class="w-full" label="To Template Name">
            <b-input placeholder="Type or Enter " />
          </base-input>
          <base-input class="w-full" label="Template ID">
            <b-input placeholder="Type or Enter " />
          </base-input>

          <base-input class="w-full" label="Select Type">
            <select class="form-control">
              <option disabled="true">Choose one</option>
              <option>Service-Implicit</option>
              <option>Service-Explicit</option>
              <option>Promotional</option>
            </select>
          </base-input>
          <!-- <base-input
              class="lg:w-1/2 md:w-1/2 w-full lg:ml-2 md:ml-2"
              label="Entity ID"
            >
              <div
                class="flex justify-between py-2 cursor-pointer"
                @click="openEntity = true"
              >
                <div class="flex items-center">
                  <feather-icon icon="PlusIcon" class="mr-2"></feather-icon>
                  <P class="text-primary font-semibold">Add Entity ID</P>
                </div>
                <feather-icon icon="ChevronDownIcon"></feather-icon>
              </div>
            </base-input> -->

          <base-input class="w-full" label="Template Message">
            <textarea
              class="form-control"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea>
          </base-input>

          <!-- <div class="flex justify-between">
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-2"
              value="accepted"
              unchecked-value="not_accepted"
              class="w-1/2 custom-control-inline"
            >
              <p class="font-semibold text-lg">is unicode</p>
            </b-form-checkbox>
            <b-form-checkbox
              class="w-1/2 custom-control-inline"
              id="checkbox-2"
              v-model="status"
              name="checkbox-2"
              value="accepted"
              unchecked-value="not_accepted"
            >
              <p class="font-semibold text-lg">is flash</p>
            </b-form-checkbox>
          </div> -->
          <base-button block type="primary" class="text-lg mt-4"
            >Create Template</base-button
          >
        </div>

        <div class="w-1/2 pl-6">
          <TemplatePreview />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddTemplateEntity from "./AddTemplateEntity";
import TemplatePreview from "./TemplatePreview";
export default {
  data() {
    return {
      openEntity: false,
    };
  },
  components: {
    AddTemplateEntity,
    TemplatePreview,
  },
};
</script>
